import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.8888 2C20.8888 2 20.9315 2.05148 21 2.14672C21.2814 2.53779 22 3.66668 22 4.9989C22 5.83805 21.6171 6.59672 21 7.14114C20.3988 7.67151 19.5753 7.99854 18.6669 7.99854C17.9238 7.99854 17.2374 7.77968 16.683 7.40969C15.864 6.86314 15.3331 5.98679 15.3331 4.9989C15.3331 5.9869 14.8023 6.86333 13.9834 7.40987C13.4292 7.77975 12.743 7.99854 12 7.99854C11.2569 7.99854 10.5705 7.77968 10.0161 7.40969C9.19706 6.86314 8.66613 5.98679 8.66613 4.9989C8.66613 5.9869 8.13537 6.86333 7.31646 7.40987C6.76224 7.77975 6.07605 7.99854 5.33306 7.99854C4.42469 7.99854 3.60119 7.67151 3 7.14114C2.38288 6.59672 2 5.83805 2 4.9989C2 3.66668 2.71856 2.53779 3 2.14672C3.06854 2.05148 3.11116 2 3.11116 2H20.8888Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.6669 9.99854C19.479 9.99854 20.2778 9.81913 21 9.48985V19.9961H22V22H16.5V14H7.5V22H2V19.9961H3V9.48985C3.72221 9.81913 4.52103 9.99854 5.33306 9.99854C6.54353 9.99854 7.72463 9.5999 8.66637 8.9004C9.60839 9.59994 10.7897 9.99854 12 9.99854C13.2105 9.99854 14.3916 9.5999 15.3333 8.9004C16.2753 9.59994 17.4566 9.99854 18.6669 9.99854Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.5 22V16H14.5V22H9.5Z"}}]};

const Shop5Filled = Vue.extend<IconProps>({
  name: 'Shop5FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'shop-5-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Shop5Filled;
